import { render } from "./AssignmentViewer.vue?vue&type=template&id=faa5fcb8&scoped=true"
import script from "./AssignmentViewer.vue?vue&type=script&lang=js"
export * from "./AssignmentViewer.vue?vue&type=script&lang=js"

import "./AssignmentViewer.vue?vue&type=style&index=0&id=faa5fcb8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-faa5fcb8"]])

export default __exports__